module.exports = __webpack_public_path__ + "img/preview2.8dc668c4.webp";